import React from 'react'
import classNames from 'classnames'

import TmoButton from '../tmoButtons/TmoButton'
import Modal from './Modal'
import TmoH1 from '../tmoControlWrappers/TmoH1'

import style from './ConfirmationModal.module.css'

const Confirmation = ({
  isOpen,
  onAcceptBtnClicked,
  onDenyBtnClicked,
  buttonsDisabled,
  title,
  message,
  acceptBtnTitle,
  denyBtnTitle,
  modalType,
  testId
}) => {
  return (
    <Modal isOpen={isOpen} label={title} transitionName='modal-anim'>
      <div
        className={classNames(style[modalType], style.container)}
        data-testid={testId}
      >
        <div className={style.header}>
          <TmoH1 className={style.heading}>{title}</TmoH1>
        </div>
        <div className={style.message}>
          <span>{message}</span>
        </div>
        <div className={style.button_container}>
          <TmoButton
            className={classNames(style.button, style.button_cancel)}
            onClick={onDenyBtnClicked}
            disabled={buttonsDisabled}
            type={modalType === 'primary' ? 'magenta_link' : 'secondary'}
            testId={'denyBtn'}
          >
            {denyBtnTitle}
          </TmoButton>
          <TmoButton
            type={modalType === 'primary' ? 'magenta_primary' : 'primary'}
            className={style.button}
            onClick={onAcceptBtnClicked}
            disabled={buttonsDisabled}
            testId={'acceptBtn'}
          >
            {acceptBtnTitle}
          </TmoButton>
        </div>
      </div>
    </Modal>
  )
}

export default Confirmation
